export default {
  columnHeader: {
    simulatedDuration: 'Simulovaná doba trvania',
  },
  acceptSimulatedDuration: 'Prijať simulovanú dobu trvania: {0}',
};
